module.exports = __webpack_public_path__ + "static/img/061_TO8_1617.09faf1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/061_TO8_1617.jpg
// module id = 4Ybu
// module chunks = 0